<div class="input-group has-clear" ngbDropdown placement="bottom-left auto" container="body">

  <ng-container *ngIf="hasFilters()">
    <div class="input-group-text c-hand" ngbDropdownToggle>
      <span class="caret" aria-haspopup="menu" role="button"></span>
    </div>

    <div role="menu" ngbDropdownMenu>
      <ng-container *ngFor="let group of filters">
        <h6 class="dropdown-header">{{ group.title }}</h6>

        <button *ngFor="let filter of group.children" (click)="onFilterClick(filter)" class="dropdown-item">
          <my-global-icon [ngClass]="{ 'no-visible': !isFilterEnabled(filter) }" iconName="tick"></my-global-icon>

          {{ filter.label }}
        </button>
      </ng-container>
    </div>
  </ng-container>

  <input
    type="text" name="table-filter" id="table-filter" i18n-placeholder placeholder="Filter..."
    class="last-in-group"
    [(ngModel)]="searchValue"
    (keyup)="onInputSearch($event)"
  >

  <my-global-icon iconName="cross" role="button" class="form-control-clear" title="Clear filter" i18n-title (click)="onResetTableFilter()"></my-global-icon>
</div>
